import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Pagination, Container, Button, IconButton, Chip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { CardActionArea } from '@mui/material';
import logo_between from '../../../public/assets/logo_between.png';
import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EditCustomerModal from './EditCustomerModal';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import { format } from 'date-fns';
import toast from 'react-hot-toast';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
const useStyles = makeStyles((theme) => ({
    customerAdminDetailsContainer: {
        // [theme.breakpoints.down('md')]: {
        //     width: '1000px',
        //     margin: '0 auto',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1000px',
        //     margin: '0 auto',
        // },
    },
    customerAdminDetailsAssignment: {
        // width: 1151,
        marginTop: '20px',
        maxHeight: '1000px',
        overflowY: 'hidden',
        borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
            // width: '950px',
            borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            // width: '950px',
            borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        },
    },
    customerAdminDetailsCardAssignments: {
        width: 193,
        height: 232,
        [theme.breakpoints.down('md')]: {
            width: 153,
            height: 232,
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: 153,
            height: 232,
        },
    }
}));
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
const CustomerAdminDetails = () => {
    let { id } = useParams();
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const [Loading, setLoading] = useState(false);
    const [expandedAssignment, setExpandedAssignment] = React.useState(false);
    const [customersDetails, SetCustomersDetails] = useState('');
    const [CustomersDetailsAssign, SetCustomersDetailsAssign] = useState([]);

    const handleExpandAssignmentClick = () => {
        setExpandedAssignment(!expandedAssignment);
    };

    const handleBack = () => {
        navigate('/customers')
    }

    const getCustomersDetails = async (id) => {
        try {
            setLoading(true);
            const res = await LeadService.customerDetails(id);
            if (res?.data?.success) {
                SetCustomersDetails(res?.data?.customer);
                SetCustomersDetailsAssign(res?.data?.customer?.customer_jobs);
            }
        } catch (error) {
            toast.error(error.message);

        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getCustomersDetails(id)
    }, []);

    const HandleChangePaused = async (id) => {
        try {
            let newStatus;
            if (customersDetails?.pause === '0') {
                newStatus = '1';
            } else {
                newStatus = '0';
            }
            setLoading(true);
            const res = await LeadService.pauseUnpauseCustomer(id, newStatus);
            if (res?.data?.success) {

                toast.success(res?.data?.message)
                await getCustomersDetails(id)
                return;
            }
        } catch (error) {
            toast.success(error?.message)
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const handleNavigateToJobDetails = async (id, type, user_type, customerId) => {

        if (type === 'Schedule a tour' || type === 'Home valuation') {
            const job_type = 'meeting';
            navigate(`/admin-job-details/${id}`, { state: { job_type: job_type, user_type: user_type, customerId: customerId } });
        } else if (type === 'Services') {
            const job_type = 'service';
            navigate(`/admin-Services-details/${id}`, { state: { job_type: job_type, user_type: user_type, customerId: customerId } });
        } else {
            console.error("routes not found")
        }

    }

    return (
        <div className={classes.customerAdminDetailsContainer}>
            <Box>
                <Button onClick={handleBack}
                    sx={{ background: '#efefef', padding: '6px', '&:hover': { background: '#cecaca' }, }}>
                    <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                </Button>
            </Box>
            <div style={{ marginBottom: '15px' }}> {Loading && <LinearProgress />}</div>
            <Container style={{
                padding: '20px',
                background: 'white',
                border: '1px solid #BCBCBC',
                marginTop: '25px',
                borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
            }}>
                <Box >
                    <Box style={{ display: 'grid', justifyContent: 'center', gap: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Avatar
                                src={`https://iconnctapp.com/` + customersDetails?.profile_image}
                                alt="Cindy Baker"
                                sx={{ height: '90px', width: '90px' }}
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            {customersDetails?.pause == null ? null : (
                                <>
                                    {customersDetails?.pause === '0' ? (
                                        <Chip label="Pause" color="success" variant="outlined" size="small" style={{ fontSize: '14px', cursor: 'pointer' }} onClick={() => HandleChangePaused(id)} />

                                    ) : (
                                        <Chip label="Unpause" color="error" variant="outlined" size="small" style={{ fontSize: '14px', cursor: 'pointer' }} onClick={() => HandleChangePaused(id)} />
                                    )}
                                </>
                            )}
                        </div>
                        <div >
                            <Typography sx={{ fontSize: {
                                xs: '18px',
                                sm: '20px',
                                md: '24px'
                            }, fontWeight: 'bold', color: 'black' }}>{customersDetails?.name} {customersDetails?.last_name}</Typography>
                        </div>

                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: {
                        xs: '15px',
                        sm: '20px',
                        md: '25px'
                    }, }}>
                        {customersDetails?.phone &&
                            <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
                                <PhoneIcon sx={{
                                    width: {
                                        xs: '15px',
                                        sm: '20px',
                                        md: '25px'
                                    },
                                    height: {
                                        xs: '15px',
                                        sm: '20px',
                                        md: '25px'
                                    }
                                }}/>  <Typography sx={{ fontSize: {
                                xs: '14px',
                                sm: '16px',
                                md: '20px'
                            }, color: '#454545' }}>{customersDetails?.phone}</Typography>
                            </div>
                        }
                        <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
                            <EmailIcon  sx={{
                                    width: {
                                        xs: '15px',
                                        sm: '20px',
                                        md: '25px'
                                    },
                                    height: {
                                        xs: '15px',
                                        sm: '20px',
                                        md: '25px'
                                    }
                                }}/> <Typography sx={{ fontSize: {
                                xs: '14px',
                                sm: '16px',
                                md: '20px'
                            }, color: '#454545' }}>{customersDetails?.email}</Typography>
                        </div>
                    </Box>
                    <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <DateRangeIcon  sx={{
                                    width: {
                                        xs: '15px',
                                        sm: '20px',
                                        md: '25px'
                                    },
                                    height: {
                                        xs: '15px',
                                        sm: '20px',
                                        md: '25px'
                                    }
                                }}/>  <Typography sx={{ fontSize: {
                                xs: '14px',
                                sm: '16px',
                                md: '20px'
                            }, color: '#454545' }}>Member Since {customersDetails?.created_at ? format(new Date(customersDetails?.created_at), "MMMM dd, yyyy") : null}</Typography>
                        </div>
                    </Box>
                    <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                        <EditCustomerModal
                            customerId={id}
                            phone={customersDetails?.phone}
                            first_name={customersDetails?.name}
                            last_name={customersDetails?.last_name}
                            profile_Image={customersDetails?.profile_image}
                            getCustomersDetails={getCustomersDetails}
                        />
                    </Box>

                </Box>

                {customersDetails.bio ? (
                    <>
                        <Box style={{
                            display: 'grid',
                            background: '#F3F6FB33',
                            border: '1px solid #CFCFCF',
                            padding: '15px',
                            marginTop: '15px',
                            borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                        }}>
                            <div >
                                <Typography style={{ fontSize: '18px', fontWeight: '700', color: 'black' }}>About Me</Typography>
                            </div>
                            <div>
                                <Typography style={{ fontSize: '14px', color: '#606060', textAlign: 'justify' }}>
                                    {customersDetails?.bio}
                                </Typography>
                            </div>

                        </Box>
                    </>
                ) : (
                    <>

                    </>
                )}



                <Card
                style={{borderRadius:'22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'}}
                    className={classes.customerAdminDetailsAssignment}
                >
                    <Box style={{ display: 'flex', marginTop: '10px', padding: '10px' }}>
                        <Typography
                            style={{
                                fontSize: '25px',
                                fontWeight: '700',
                                color: '#414D55'
                            }}>Assignments</Typography>
                    </Box>
                    <CardActions disableSpacing style={{ display: 'flex', justifyContent: 'flex-end', }}>
                        {CustomersDetailsAssign?.length >= 3 && (
                            <>
                                <ExpandMore
                                    expand={expandedAssignment}
                                    onClick={handleExpandAssignmentClick}
                                    aria-expanded={expandedAssignment}
                                    aria-label="show more"
                                >
                                    <Typography style={{ color: '#5379BD', fontSize: '16px', fontWeight: '700', display: 'flex', justifyContent: 'flex-end' }}>
                                        {expandedAssignment ? "View Less" : "View More"}
                                    </Typography>
                                </ExpandMore>
                            </>
                        )
                        }
                    </CardActions>
                    <Box>
                        {!expandedAssignment && (
                            <Box style={{ display: 'flex' }}>
                                {CustomersDetailsAssign?.length > 0 ? (
                                    CustomersDetailsAssign?.slice(0, 5)?.map((customer, index) => (
                                        <CardContent key={index} onClick={() => handleNavigateToJobDetails(customer?.id, customer?.type, customersDetails?.user_type, customersDetails?.id)}>

                                            <Card
                                                className={classes.customerAdminDetailsCardAssignments}
                                            >
                                                <CardActionArea>
                                                    <div style={{ position: 'relative' }}>
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '53px',
                                                                left: '50%',
                                                                transform: 'translateX(-50%)',
                                                                zIndex: 10,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                borderRadius: '4px',
                                                                padding: '5px',
                                                            }}
                                                        >
                                                            <img src={logo_between} alt="" style={{ width: '44px', height: '44px' }} />
                                                        </div>
                                                    </div>

                                                    <img
                                                        src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=450x200&maptype=roadmap&center=${customer?.latitude},${customer?.longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                        alt=""
                                                        style={{ width: '470px', height: '120px', borderRadius: '10px' }}
                                                    />
                                                    <CardContent>
                                                        <Typography style={{ fontSize: '12px', fontWeight: '700', color: '#414D55' }}>
                                                            {customer?.assign_to?.name} {customer?.assign_to?.last_name}
                                                        </Typography>


                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                            <div
                                                                style={{
                                                                    borderRadius: '8px',
                                                                    display: 'flex',
                                                                    gap: '2px',
                                                                    marginRight: '-14px',
                                                                    backgroundColor: customer?.type === 'Services' ? '#e3a4a4' : customer?.type === 'Schedule a tour' ? '#cacad7' : customer?.type === 'Home valuation' ? '#a6dfac' : 'transparent',
                                                                    padding: '10px',
                                                                }}
                                                            >
                                                                <div style={{ marginTop: '-3px', cursor: 'pointer' }}>
                                                                    <span style={{ fontSize: '12px' }}>{customer?.type}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </CardContent>
                                    ))
                                ) : (
                                    <></>
                                )}
                            </Box>
                        )}
                    </Box>

                    <Grid container spacing={2} style={{ marginLeft: '1px', marginBottom: '10px' }}>
                        {CustomersDetailsAssign?.length > 0 ? (
                            CustomersDetailsAssign?.map((customer, index) => (
                                <div key={index}  >
                                    <Grid item xs={6} md={3} lg={3} >
                                        <Collapse in={expandedAssignment} timeout="auto" unmountOnExit>
                                            <CardContent onClick={() => handleNavigateToJobDetails(customer?.id, customer?.type, customersDetails?.user_type, customersDetails?.id)} >
                                                <Card sx={{ width: 193, height: "auto",borderRadius:'22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'}} key={index}>
                                                    <CardActionArea>
                                                        <div style={{ position: 'relative' }}>
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '53px',
                                                                    left: '50%',
                                                                    transform: 'translateX(-50%)',
                                                                    zIndex: 10,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    borderRadius: '4px',
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                <img src={logo_between} alt="" style={{ width: '44px', height: '44px' }} />
                                                            </div>
                                                        </div>

                                                        <img
                                                            src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=450x200&maptype=roadmap&center=${customer?.latitude},${customer?.longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                            alt=""
                                                            style={{ width: '470px', height: '120px', borderRadius: '10px' }}
                                                        />


                                                        <CardContent>
                                                            <Typography style={{ fontSize: '12px', fontWeight: '700', color: '#414D55' }}>
                                                                {customer?.assign_to?.name} {customer?.assign_to?.last_name}
                                                            </Typography>
                                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                                <div
                                                                    style={{
                                                                        borderRadius: '8px',
                                                                        display: 'flex',
                                                                        gap: '2px',
                                                                        marginRight: '-14px',
                                                                        backgroundColor: customer?.type === 'Services' ? '#e3a4a4' : customer?.type === 'Schedule a tour' ? '#cacad7' : customer?.type === 'Home valuation' ? '#a6dfac' : 'transparent',
                                                                        padding: '10px',

                                                                    }}
                                                                >
                                                                    <div style={{ marginTop: '-3px', cursor: 'pointer' }}>
                                                                        <span style={{ fontSize: '12px' }}>{customer?.type}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardContent>
                                                    </CardActionArea>
                                                </Card>
                                            </CardContent>

                                        </Collapse>
                                    </Grid>
                                </div>
                            ))
                        ) : (
                            <>
                                <Grid container spacing={2} style={{ justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                                    <CardContent >
                                        <Typography style={{ fontWeight: 'bold', textAlign: 'center' }}>No records found!</Typography>
                                    </CardContent>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Card>

            </Container>
        </div>
    )
}

export default CustomerAdminDetails
